module.exports = __webpack_public_path__ + "static/media/defaultAvatar24.ccc7a049.svg";